import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submitter"]
  loadingElementId = ""

  connect() {
    this.element.addEventListener("change", (e) => {
      this.updateSrc(e);
    })
  }


  updateSrc(e) {
    const imageTag = this.element.closest('[data-type=image-upload]').querySelector('[data-type=image]');
    if (this.element.files.length > 0) {
      const fr = new FileReader();
      fr.onload = function () {
        imageTag.src = fr.result;
      }
      fr.readAsDataURL(this.element.files[0]);
    } else {
      imageTag.src = imageTag.dataset.blankSrc;
    }
  }
}